
import React from "react";
import MovieDetailsDialog from "@/components/movie/MovieDetailsDialog";
import { useMovieDialogContext } from "@/context/dialog/MovieDialogContext";
import { useMovieDialog } from "@/hooks/useMovieDialog";
import { useMovieData } from "@/hooks/movie/useMovieData";

/**
 * Simplified MovieDialogManager using unified data fetching
 * Pure camelCase logging with tmdbId only
 */
const MovieDialogManager: React.FC = () => {
  const { state } = useMovieDialogContext();
  const { expandedMovieId, closeDialog } = useMovieDialog();
  
  // Use unified movie data hook
  const { movie, isLoading, isError, error, refetch } = useMovieData(expandedMovieId);
  
  const isOpen = !!expandedMovieId;
  
  // Don't render if not open
  if (!isOpen) return null;
  
  // Log state for debugging - Pure camelCase
  if (process.env.NODE_ENV === 'development') {
    console.log("MovieDialogManager rendering:", {
      title: movie?.title || 'unknown',
      tmdbId: movie?.tmdbId || expandedMovieId || 'unknown',
      isOpen,
      isLoading,
      hasError: isError
    });
  }
  
  return (
    <MovieDetailsDialog
      movie={movie}
      isExpanded={isOpen}
      setIsExpanded={(isOpen) => {
        if (!isOpen) {
          closeDialog();
        }
      }}
      fromCard={true}
      viewVariant="detail"
      isLoading={isLoading || state.isLoading}
      loadError={isError && error ? error.message : state.loadError}
    />
  );
};

export default MovieDialogManager;
